import { ParseMapOptions, ParsingMap } from "@/components/parser/types";
import { Figcaption, Heading, Paragraph } from "@/components/parser/Typography";
import { Table } from "@/components/parser/Table";
import { Element } from "html-react-parser";
import { List } from "@/components/parser/Lists";
import { Iframe } from "@/components/parser/Media";

export const parseMap: ParsingMap = {
  h1: Heading,
  h2: Heading,
  h3: Heading,
  h4: Heading,
  h5: Heading,
  p: Paragraph,
  table: Table,
  thead: Table,
  th: Table,
  tr: Table,
  td: Table,
  ul: List,
  ol: List,
  iframe: Iframe,
  figcaption: Figcaption,
};

export const parseByNodeString = (
  parseMap: ParsingMap,
  nodeName: string,
  domNode: Element,
  options: ParseMapOptions
) => {
  return parseMap[nodeName] ? parseMap[nodeName](domNode, options) : undefined;
};
